import { unwrap, unwrapUpsert, unwrapVoid } from '../http.js';
export function createMealsApi(client) {
    return {
        async day(query) {
            return unwrap(await client.GET('/v1/meals/day', { params: { query: query ?? {} } }));
        },
        async range(query) {
            return unwrap(await client.GET('/v1/meals/range', { params: { query } }));
        },
        async upsert(clientId, body) {
            const { value, created } = unwrapUpsert(await client.PUT('/v1/meals/{clientId}', { params: { path: { clientId } }, body }));
            return { entry: value, value, created };
        },
        async remove(clientId) {
            unwrapVoid(await client.DELETE('/v1/meals/{clientId}', { params: { path: { clientId } } }));
        },
        async sync(body) {
            return unwrap(await client.POST('/v1/meals/sync', { body }));
        },
        async markEaten(clientIds) {
            return unwrap(await client.POST('/v1/meals/mark-eaten', { body: { clientIds } }));
        },
    };
}
//# sourceMappingURL=meals.js.map